document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        let snizeFakeResults = [];
        let snizeSuggestionsCount = Searchanise.GetWidgets().options.AutocompleteSuggestionCount;            
        let isNothingFound = false;

        let quickLinks = {
            'Size guide': 'https://www.sachadrake.com/pages/size-guide',
            'Contact Us': 'https://www.sachadrake.com/pages/contact',
            'FAQs': 'https://www.sachadrake.com/pages/faq',
            'Returns': 'https://www.sachadrake.com/pages/returns',
            'Shipping': 'https://www.sachadrake.com/policies/shipping-policy',
            'Brisbane Boutiques': 'https://www.sachadrake.com/pages/sacha-drake-boutique',
        };

        async function insertFakeResults(container, input) {
            if (!snizeFakeResults.length) {
                $('.snize-ac-results-content:not(.hidden)').addClass('hidden');
                await $.get('https://searchserverapi.com/getresults?api_key=3x4t6n2g0o&sortBy=sales_amount&sortOrder=desc&items=true&facets=false', function(data) {
                    snizeFakeResults = JSON.parse(data).items;
                });
            }
            
            $('.snize-ac-results-content.hidden').removeClass('hidden');

            if (isNothingFound || window.innerWidth > 1024 && !input.prop('value') || window.innerWidth < 1024 && !$('#snize-mobile-search-input').hasClass('is-filled')) {
                $('.snize-no-products-found').remove();
                $('#snize-ac-items-container-4 .snize-label', container).text('NOW TRENDING');
                $('#snize-ac-items-container-1').show();

                if (!$('#snize-ac-items-container-4 .snize-label', container).length) {
                    $('#snize-ac-items-container-4', container).prepend(`
                        <li id="snize-products-label" class="snize-label" aria-hidden="true"></li>  
                    `);
                }

                if (!$('.snize-quick-links').length) {
                    $('#snize-ac-items-container-1').after(`
                        <ul class="snize-ac-results-list snize-quick-links" id="snize-ac-items-container-2" aria-labelledby="snize-quick-links-label" role="group">
                            <li id="snize-quick-links-label" class="snize-label" aria-hidden="true">Quick Links</li>
                        </ul>
                    `);
    
                    Object.entries(quickLinks).forEach(([text, link]) => {
                        $('.snize-quick-links').append(`
                            <li class="snize-category" id="snize-category-0" role="button" style="cursor: pointer;"><a href="${link}" class="snize-view-link" data-no-instant="true">${text}</a></li>
                        `)
                    });
                }

                snizeFakeResults.forEach((item) => {
                    if ($('.snize-product', container).length == 5) {
                        return;
                    }
                    if (window.innerWidth > 1024) {
                        $('#snize-ac-items-container-4', container).append(
                            `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;">
                                <a href=${item.link} class="snize-item" draggable="false">
                                    <div class="snize-thumbnail">
                                        <img src=${item.image_link} class="snize-item-image " alt="${item.title}">
                                    </div>
                                    <span class="snize-sku">${item.product_code}</span>
                                    <span class="snize-title">${item.title}</span>
                                    <div class="snize-price-list">
                                        <span class="snize-price snize-price-with-discount money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span>
                                            ${
                                                item.list_price !== '0.0000' && item.price < item.list_price
                                                    ? `<span class="snize-discounted-price money">${Searchanise.GetWidgets().formatPrice(item.list_price)}</span>`
                                                    : ''
                                            }
                                    </div>
                                </a>
                            </li>`
                        );
                    } else {
                        $('#snize-ac-items-container-4', container).append(
                            `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;">
                                <a href="${item.link}" class="snize-item">
                                    <div class="snize-thumbnail">
                                        <img src="${item.image_link}" class="snize-item-image " alt="${item.title}">
                                    </div>
                                    <div class="snize-product-info">
                                        <span class="snize-sku">${item.product_code}</span>
                                        <span class="snize-title">${item.title}</span>
                                        <div class="snize-ac-prices-container">
                                            <div class="snize-price-list">
                                                <span class="snize-price snize-price-with-discount money theme-money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span>
                                                ${
                                                    item.list_price !== '0.0000' && item.price < item.list_price
                                                        ? `<span class="snize-discounted-price money">${Searchanise.GetWidgets().formatPrice(item.list_price)}</span>`
                                                        : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>`
                        );
                    }
                });
                $('.snize-ac-results-columns', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-4', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-2', container).removeClass('snize-hidden');  
            } else {
                setTimeout(() => $('#snize-ac-items-container-1').hide(), 100);
                $('#snize-ac-items-container-4 .snize-label', container).text('PRODUCTS')
                $('.snize-product', container).each(function() {
                    $('.snize-title', this).before($('.snize-sku', this));
                });
            }
        }
        
        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (params.q && !data.items.length) {
                isNothingFound = true;
            }
        });
        
        $(document).on("Searchanise.AutocompleteUpdated", function(event, input, container) {
            insertFakeResults(container, input);

            if (!$('.snize-suggestion').length) {
                $('#snize-ac-items-container-2', container).addClass('snize-suggestions-modified').append(`<li class="snize-label">POPULAR SEARCHES</li>`);

                Searchanise.preloadedSuggestions.forEach((item, index) => {
                    if(index < Number(snizeSuggestionsCount)) {
                        let oddOrEven = (index + 1) % 2 ? 'snize-ac-odd' : 'snize-ac-even'; 
                        $('#snize-ac-items-container-2.snize-suggestions-modified').append(`<li class="snize-suggestion ${oddOrEven}" style="cursor: pointer;">${item}</li>`);
                    }
                });
                
                $('.snize-suggestions-modified').on('click', (e) => {
                    if(e.target.className.includes('snize-suggestion')) {
                        input[0].value = e.target.innerText;
                        let searchQuery = encodeURI(e.target.innerText);
                        window.location.href = 'https://www.sachadrake.com/pages/search-results-page?q=' + searchQuery;
                    }
                });
                
                $('.snize-suggestions-modified').on('mouseout', (e) => {
                    if(e.target.className.includes('snize-suggestion')) {
                        e.target.classList.remove('snize-ac-over-nodrop-mouse');
                        e.target.classList.remove('snize-ac-over-nodrop');
                    }
                });
            } else {
                $('#snize-ac-items-container-2', container).removeClass('snize-suggestions-modified');
            }
            
        });
    })(window.Searchanise.$);
});

